export enum RelationshipOptions {
  Self = 'Self',
  Husband = 'Husband',
  Wife = 'Wife',
  Son = 'Son',
  Daughter = 'Daughter',
  Father = 'Father',
  Mother = 'Mother',
  Brother = 'Brother',
  Sister = 'Sister',
  Spouse = 'Spouse',
}
